<span [ngClass]="{'p-autocomplete p-widget':true,'p-autocomplete-dd':dropdown,'p-autocomplete-multiple':multiple}"
      [ngStyle]="style" [class]="styleClass"
      (clickOutside)="focus ? onInputBlur({originalEvent : $event, value: value}) : null">
            <input *ngIf="!multiple && !itemLabel"
                   #in pInputText
                   type="text"
                   [ngStyle]="inputStyle"
                   [class]="inputStyleClass"
                   autocomplete="off"
                   [value]="value ? objectUtilsResolveFieldData(value,field)||value : null"
                   (input)="onInput($event)"
                   (keydown)="onKeydown($event)"
                   (focus)="onInputFocus($event);selecInputContent()"
                   [attr.placeholder]="placeholder" [attr.size]="size" [attr.maxlength]="maxlength"
                   [attr.tabindex]="tabindex" [readonly]="readonly" [disabled]="disabled"
                   [ngClass]="{'p-autocomplete-input':true,'p-autocomplete-dd-input':dropdown}">
            <input *ngIf="!multiple && itemLabel"
                   #in pInputText
                   type="text"
                   [ngStyle]="inputStyle"
                   [class]="inputStyleClass"
                   autocomplete="off"
                   [value]="value && value[field] ? value[field] : value"
                   (input)="onInput($event)"
                   (keydown)="onKeydown($event)"
                   (focus)="onInputFocus($event);selecInputContent()"
                   [attr.placeholder]="placeholder" [attr.size]="size" [attr.maxlength]="maxlength"
                   [attr.tabindex]="tabindex" [readonly]="readonly" [disabled]="disabled"
                   [ngClass]="{'p-autocomplete-input':true,'p-autocomplete-dd-input':dropdown}">
    <ul *ngIf="multiple"
        class="p-autocomplete-multiple-container p-widget p-inputtext p-state-default p-corner-all"
        [ngClass]="{'p-state-disabled':disabled,'p-state-focus':focus}"
        (click)="multiIn.focus()">
        <li #token *ngFor="let val of value" class="p-autocomplete-token p-state-highlight p-corner-all">
            <fa-icon [icon]="iconClose" class="p-autocomplete-token-icon" fixedWidth="fixedWidth"
                     (click)="removeItem(token)"
                     *ngIf="!disabled"></fa-icon>
            <span *ngIf="!selectedItemTemplate" class="p-autocomplete-token-label">{{field ? val[field] : val}}</span>
            <ng-container *ngTemplateOutlet="selectedItemTemplate; context: {$implicit: val}"></ng-container>
        </li>
        <li class="p-autocomplete-input-token">
            <input #multiIn
                   type="text"
                   [disabled]="disabled"
                   pInputText
                   [attr.placeholder]="placeholder"
                   [attr.tabindex]="tabindex"
                   (input)="onInput($event)"
                   (keydown)="onKeydown($event)"
                   (focus)="onInputFocus($event)"
                   (blur)="onInputBlur($event)" autocomplete="off">
        </li>
    </ul>

    <button type="button"
            pButton
            icon="fa-caret-down"
            class="p-autocomplete-dropdown"
            [disabled]="disabled"
            (click)="handleDropdownClick($event)"
            *ngIf="dropdown"></button>
    <div #panel class="p-autocomplete-panel p-widget-content p-corner-all p-shadow"
         *ngIf="panelVisible && suggestions && suggestions.length"
         [style.width]="appendTo ? 'auto' : '100%'" [style.max-height]="scrollHeight">
        <ul class="p-autocomplete-items p-autocomplete-list p-widget-content p-widget p-corner-all p-helper-reset">
            <li *ngFor="let option of suggestions; let idx = index"
                [ngClass]="{'p-autocomplete-list-item p-corner-all':true,'p-state-highlight':(highlightOption==option)}"
                (mouseenter)="highlightOption=option" (mouseleave)="highlightOption=null" (click)="selectItem(option)">
                <span class="li-icon-container"
                      *ngIf="option.type && (option.type === 'Airport' || option.type === 'City')">
                    <fa-icon [icon]="iconPlane" *ngIf="option.type === 'Airport'"></fa-icon>
                    <fa-icon [icon]="iconMapMarker" *ngIf="option.type === 'City'"></fa-icon>
                </span>
                <span *ngIf="!itemTemplate && !itemLabel">{{field ? option[field] : option}}</span>
                <span *ngIf="!itemTemplate && itemLabel">{{getLabel(option)}}</span>
                <ng-container *ngTemplateOutlet="itemTemplate; context: {$implicit: option, index: idx}"></ng-container>
            </li>
        </ul>
    </div>
</span>
